import * as actionTypes from './actionTypes';
import { fetchAppliedJobsList } from "../../../services/appliedJobs.service";

export const setAppliedJobsData = (data) => {
  return {
    type: actionTypes.SET_APPLIED_JOBS,
    data,
  }
}

export const getAppliedJobs = (params="") => {
  return dispatch => {
    dispatch({ type: actionTypes.SET_APPLIED_JOBS_LOADING })
    return fetchAppliedJobsList(params).then(res => {
      dispatch(setAppliedJobsData(res?.data));
      return res;
    }).catch(err => {
      console.log(err);
      return [];
    });
  }
}
